var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramMobileCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 18,
  viewBox: "0 0 20 18",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11.642 0c.296 0 .58.12.785.333l2.31 2.394h1.99A3.273 3.273 0 0 1 20 6v8.727A3.273 3.273 0 0 1 16.727 18H3.273A3.273 3.273 0 0 1 0 14.727V6a3.273 3.273 0 0 1 3.273-3.273h1.989L7.573.333A1.1 1.1 0 0 1 8.358 0zM10 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10m0 1.111a3.889 3.889 0 1 1 0 7.778 3.889 3.889 0 0 1 0-7.778"
})));
export default SvgInstagramMobileCamera;